import { useUnit } from 'effector-react'
import { $isUserGamedPremium, $userBalance, $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { $steamUserData } from '@/entities/platforms/steam/store'
import { useStyles } from './styles'
import { useEffect, useState } from 'react'
import { AccStatsList } from '@/features/accStatsList'
import Break from '@/shared/ui/break'
import { formatNumber } from '@/shared/util/formatNumber'
import { ItemsList } from '@/features/profileTabs/itemsList'
import { CoinIcon } from '@/shared/ui/icons'
import { AppButton } from '@/shared/ui/button'
import { ListObjectType } from '@/features/updateView/types'
import { goToMain } from '@/app/routing/events'
import { useHideNav } from '@/shared/hooks/useHideNav'
import ButtonWrapper from '@/shared/ui/buttonWrapper'
import { usePostStory } from '@/shared/hooks/usePostStory'
import { ProfileCard } from '@/features/profileCard'

export const LastProgress = () => {
  useHideNav()
  const userLang = useUnit($userLanguage)
  const steamUserData = useUnit($steamUserData)
  const balance = useUnit($userBalance)
  const texts = lang[userLang].pages.updatePage
  const units = lang[userLang].pages.units
  const btnTexts = lang[userLang].pages.btnTexts
  const { canShareStory, isMakingStoryLink, handleShareStory } = usePostStory()
  const { classes } = useStyles()
  const data: ListObjectType[] = [
    {
      name: texts.games_owned,
      value: steamUserData!.userData!.gamesOwned,
    },
    {
      name: texts.items_owned,
      value: steamUserData!.userData!.itemsOwned,
    },
    {
      name: texts.total_playtime,
      value: steamUserData!.userData!.totalHoursPlayed,
      unit: units.hours,
    },
    {
      name: texts.account_value,
      value: `$ ${steamUserData!.userData!.totalValue}`,
    },
    {
      name: texts.inventory_price,
      value: '$ ' + steamUserData!.userData!.inventoryPrice,
      isPlus: true,
    },
    {
      name: texts.account_age,
      value: steamUserData!.userData!.accountAge,
      isPlus: true,
      unit: units.years,
    },
  ]

  const [totalReward, setTotalReward] = useState<number>(0)

  const isPlusUser = useUnit($isUserGamedPremium)

  useEffect(() => {
    if (steamUserData) {
      setTotalReward(
        steamUserData.scoring_diff!.games_owned +
          steamUserData.scoring_diff!.total_hours +
          steamUserData.scoring_diff!.inventory_price
      )
    }
  }, [steamUserData, texts])

  const secondaryTitle = {
    totalValue: formatNumber(balance),
    rewardInfo: totalReward ? totalReward : 0,
  }

  return (
    <div
      id="updateScreen"
      className={classes.root}
    >
      <ProfileCard variant="standard" />
      <div className={classes.content}>
        <div className={classes.title}>{texts.total_value}</div>

        <div className={classes.totalValue}>
          + {secondaryTitle.totalValue} <CoinIcon />
        </div>
      </div>
      <AccStatsList
        propValue={data}
        isPlusUser={isPlusUser}
      />
      <Break />
      <p className={classes.listTitle}>{texts.most_expensive}</p>
      <ItemsList itemsList={steamUserData ? steamUserData.itemsList : null} />
      <ButtonWrapper
        style={{
          flexDirection: 'row',
          paddingLeft: '5%',
          paddingRight: '5%',
          zIndex: 90,
        }}
      >
        <AppButton
          variant="storiesReward"
          size="large"
          isLoading={isMakingStoryLink}
          fullWidth={true}
          disabled={!canShareStory}
          onClick={handleShareStory}
        >
          {btnTexts.share2}
        </AppButton>
        <AppButton
          onClick={() => goToMain()}
          sx={{ width: '172px', height: '52px', gap: '6px' }}
          fullWidth
        >
          {btnTexts.profile}
        </AppButton>
      </ButtonWrapper>
    </div>
  )
}
